@if (isLoading()) {
    <div class="top-0 left-0 z-[1000] absolute w-full">
        <p-progressBar
            mode="indeterminate"
            [style]="{ height: '4px', backgroundColor: backgroundColor }"
            [color]="color"
        ></p-progressBar>
        @if (shouldBlockUI()) {
            <div class="fixed bg-white opacity-15 w-full h-full"></div>
        }
    </div>
}
